import React from "react";
import DefaultLayout from "../layouts/Default";
import Slider from "../utils/Slider";
import Image from "../utils/Image";
import TitleCar from "../utils/TitleCar";
import styled from "styled-components";
import { ButtonPdf } from "../utils/ButtonCAR";

const images = require.context("../../assets/img/", true);

const Grid2 = styled.div`
  display: grid;
  margin-top: 2rem;
  grid-template-columns: 48% 48%;
  column-gap: 4%;
  row-gap: 2rem;
`;

const MainBanner = () => {
  const sliders = [
    { imageURL: "./banner1.png" },
    { imageURL: "./banner1.png" },
  ];

  return (
    <Slider
      data={sliders.map((item, index) => (
        <Image
          key={index}
          src={images(item.imageURL)}
          alt={`Banner #${index + 1} de la pagina web`}
          classNameDiv="p-0"
          classNameImg="w-100"
        ></Image>
      ))}
      id="slider-banner"
      classItems="w-100"
    />
  );
};

const MarcoLegal = () => {
  return (
    <DefaultLayout>
      {/* <MainBanner /> */}
      <div className="row justify-content-center ">
        <div className="row col-11 col-lg-9 my-4">
          <div className="col-12 py-3">
            <TitleCar>
              <b>Marco Legal</b>
            </TitleCar>
            <div className="py-5" style={{ textAlign: "justify" }}>
              <p>
                La Constitución Política de Colombia otorga el derecho a todas
                las personas a gozar de un ambiente sano, imponiendo, además de
                un régimen de responsabilidad ambiental, el deber al Estado de
                planificar el manejo y aprovechamiento de los recursos
                naturales, para garantizar su desarrollo sostenible, su
                conservación, restauración o sustitución, y de proteger la
                diversidad e integridad del medio ambiente.
              </p>

              <p>
                Así mismo, dentro de los principios generales ambientales
                definidos en el artículo 1 de la Ley 99 de 1993, el que
                establece que “La acción para la protección y recuperación
                ambiental del país es una tarea conjunta y coordinada entre el
                Estado, la comunidad, las organizaciones no gubernamentales y el
                sector privado. (…)”, de igual forma, “El manejo ambiental del
                país, conforme a la Constitución Nacional, será descentralizado,
                democrático y participativo”.
              </p>

              <p>
                De acuerdo con el artículo 23 de la Ley 99 de 1993, las
                Corporaciones Autónomas Regionales, son entes corporativos de
                carácter público, encargados por el ordenamiento jurídico para
                administrar, dentro del área de su jurisdicción, el medio
                ambiente y los recursos naturales renovables y propender por su
                desarrollo sostenible, de conformidad con las disposiciones
                legales y las políticas del Ministerio del Medio Ambiente.{" "}
              </p>

              <p>
                Dentro de las funciones establecidas en el canon 31° de la
                regulación, las Corporaciones ejercen la función de máxima
                autoridad ambiental en el área de su jurisdicción, ejecutan las
                políticas, planes y programas nacionales y del orden regional
                que le hayan sido confiados conforme a la ley, promueven y
                desarrollan la participación comunitaria en actividades y
                programas de protección ambiental, de desarrollo sostenible y de
                manejo adecuado de los recursos naturales renovables; del mismo
                modo, tienen la función de celebrar contratos y convenios con
                las entidades territoriales, otras entidades públicas, privadas,
                y entidades sin ánimo de lucro, cuyo objeto es la defensa y
                protección del medio ambiente, los recursos naturales
                renovables, así como el asesoramiento de las entidades
                territoriales en la elaboración de proyectos en materia
                ambiental que deban desarrollarse con recursos provenientes del
                Fondo Nacional de Regalías, o con otros de destinación
                semejante; lo anterior, a tono con las normas de carácter
                superior y conforme a las directrices impartidas por el
                Ministerio de Ambiente y Desarrollo Sostenible MADS.
              </p>

              <p>
                El Decreto 1076 de 2015, “Por medio del cual se expide el
                Decreto Único Reglamentario del Sector Ambiente y Desarrollo
                Sostenible”, define la planificación ambiental regional,
                artículo 2.2.8.6.1.1.1, como un proceso dinámico de
                planificación del desarrollo sostenible que permite a una región
                orientar de manera coordinada el manejo, administración y
                aprovechamiento de sus recursos naturales renovables, para
                contribuir desde lo ambiental a la consolidación de alternativas
                de desarrollo sostenible en el corto, mediano y largo plazo,
                acordes con las características y dinámicas biofísicas,
                económicas, sociales y culturales.
              </p>

              <p>
                El proceso de planificación ambiental regional se regirá por los
                siguientes principios: 1. La Armonía Regional, la Gradación
                Normativa y el Rigor Subsidiario establecidos en el Título IX de
                la Ley 99 de 1993, 2. Concordancia y articulación entre los
                diferentes instrumentos de Planeación del Estado, 3. Respeto por
                la Dinámica y Procesos de Desarrollo Regional. y 4.
                Integralidad. (artículo 2.2.8.6.1.1.2. del Decreto 1076 de
                2015).
              </p>

              <p>
                De igual forma, el capítulo 6, artículo 2.2.8.6.2.1., del
                Decreto 1076 de 2015 compiló la normatividad relacionada con los
                instrumentos para la planificación ambiental, el cual define que
                las Corporaciones Autónomas Regionales para el desarrollo de la
                Planificación Ambiental Regional en el largo, mediano y corto
                plazo contarán con los siguientes instrumentos: El Plan de
                Gestión Ambiental Regional (PGAR), el Plan de Acción Cuatrienal
                y el Presupuesto anual de rentas y gastos, a saber:
              </p>
              <hr />
              <p>
                <b>Plan de Gestión Ambiental Regional PGAR:</b> Es el
                instrumento de planificación estratégico a largo plazo de las
                Corporaciones Autónomas Regionales para el área de su
                jurisdicción, el cual tendrá una vigencia de 10 años; éste
                permite orientar su gestión e integrar las acciones de todos los
                actores regionales con el fin de que el proceso de desarrollo
                avance hacia la sostenibilidad de las regiones (artículo
                2.2.8.6.3.1 del Decreto 1076 de 2015). El PGAR, incorporará los
                resultados de la priorización, así como las estrategias,
                programas y proyectos definidos en el Plan de Ordenación y
                Manejo de la Cuenca Hidrográfica, POMCAS (parágrafo 2 del
                artículo 2.2.3.1.5.5 del Decreto 1076 de 2015).
              </p>

              <p>
                <b>Plan de Acción Cuatrienal PAC:</b> Es el instrumento de
                planeación, a mediano plazo, de las Corporaciones Autónomas
                Regionales, en el cual se concreta el compromiso institucional
                de éstas para el logro de los objetivos y metas planteados en el
                Plan de Gestión Ambiental Regional. En él se definen las
                acciones e inversiones que se adelantarán en el área de su
                jurisdicción y su proyección será de 4 años. (artículo
                2.2.8.6.4.1 del Decreto 1076 de 2015).
              </p>

              <p>
                <b>Presupuesto Anual de Rentas y Gastos:</b> El presupuesto
                Anual de la Corporación Autónoma Regional de Cundinamarca,
                deberá guardar concordancia con el Plan de Acción Cuatrienal
                (artículo 2.2.8.6.4.13. del Decreto 1076 de 2015).
              </p>
              <hr />

              <p>
                Adicionalmente, el Estatuto Presupuestal de la Corporación
                Autónoma Regional de Cundinamarca CAR, determina el Presupuesto
                Anual como el instrumento de planificación y gestión de corto
                plazo que sirve para desarrollar los objetivos y metas del Plan
                de Acción vigente, su plan financiero y los proyectos de
                inversión.
              </p>

              <p>
                A su vez, establece que los programas o proyectos que hagan
                parte del Presupuesto Anual de la Corporación deberán ser
                evaluados por la Oficina Asesora de Planeación OAP.
              </p>

              <p>
                De otra parte, el Acuerdo N° 37 de 2005 establece los mecanismos
                para acceder a los recursos destinados a la cofinanciación de
                proyectos para la defensa y protección del medio ambiente y los
                recursos naturales renovables en jurisdicción de la CAR.
              </p>

              <p>
                Así mismo, la Resolución DGEN N° 20207101145 del 28 de diciembre
                de 2020, conforma y consolida el Banco de Programas y Proyectos
                de Inversión de la CAR BPPI-CAR.
              </p>

              <p>
                Y por último, la Resolución CAR N° 0070 de 16 de enero de 2018,
                por la cual actualiza el Sistema Integrado de Gestión Pública
                “SIGESPU”, en su artículo 13, conforma el comité de dirección
                para la priorización de proyectos de cofinanciación.
              </p>

              <p>
                De esta manera, la estructura de formulación, programación de
                inversión y ejecución y seguimiento del gasto de inversión de la
                CAR está reglamentado conforme a la normatividad vigente,
                metodología adoptada, procedimientos y directrices de la
                Corporación.
              </p>
            </div>

            <TitleCar>Documentos asociados</TitleCar>
            <Grid2 className="px-5">
              <ButtonPdf title="Acuerdo 26 de 2021" />
              <ButtonPdf title="Resolución 20227000152 del 8 de abril de 2022 Acuerdo 26 de 2021" />
            </Grid2>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default MarcoLegal;
